import React from "react";
import PropTypes from "prop-types";
import { H1 } from "components/core/Typography";
import { ShowNumber } from "components/brand/ClickToCall";
import { StarReviewV2 } from "components/review/StarReviewV2";
import "./FacilityPageHeader.scss";

const FacilityPageHeader = ({
	name,
	address,
	reviews,
	phone,
	scrollToReviews
}) => (
	<div className="facility-page-header">
		<H1
			mediumSize="large"
			className="facility-name"
		>
			{name}
		</H1>
		<div className="contact-info">
			<span className="facility-address">{address}</span>
			<div className="contact-details">
				<div className="gray-dot-one" />
				<ShowNumber
					color="blue"
					underline
					phone={phone}
					showNumberOnly
				/>
				<div className="gray-dot-two" />
				<StarReviewV2
					rating={reviews.average}
					reviewCount={reviews.number}
					scrollToReviews={scrollToReviews}
				/>
			</div>
		</div>
	</div>
);

FacilityPageHeader.propTypes = {
	name: PropTypes.string,
	address: PropTypes.string,
	reviews: PropTypes.object,
	phone: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	scrollToReviews: PropTypes.func
};

FacilityPageHeader.defaultProps = {
	name: "",
	address: "",
	reviews: {
		average: 0,
		number: 0
	},
	phone: "",
	scrollToReviews: () =>
		document
			.getElementById("reviews")
			?.scrollIntoView({ behavior: "smooth" })
};

export default FacilityPageHeader;
